import constants from 'constants/index'

const {
  VISUAL_IDENTITY_TAG,
  COMPANY_SITE_TAG,
  COOKIE_BANNER_TAG,
  DPO_APPOINTMENT_TAG,
  COMPANY_DOCUMENTS_TAG,
} = constants.userTrailSteps

const validRedirectionStep = (step_tag) =>
  [
    VISUAL_IDENTITY_TAG,
    COMPANY_SITE_TAG,
    COOKIE_BANNER_TAG,
    DPO_APPOINTMENT_TAG,
    COMPANY_DOCUMENTS_TAG,
  ].includes(step_tag)

export default validRedirectionStep
